import InfographicRecordFactory from "./infographic-record";
import {appContainer} from "../contexts/app";
import {fromImmutable, toImmutable, setInState, deleteInState, hydrateParent, validate} from "./hooks";

const hydrateMarker = hydrateParent("api/markers", "marker_id");

export default app => {
  const service = app.service("api/infographics");
  // Lengthen the timeout to allow for image uploads
  service.timeout = 20000;

  const InfographicRecord = InfographicRecordFactory(service);

  const validateInfographic = validate({
    marker_id: "Marker is required.",
    type: "Infographic type should be an image."
  });

  appContainer.InfographicRecord = InfographicRecord;
  app.set("InfographicRecord", InfographicRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateInfographic],
      update: [fromImmutable, validateInfographic],
      patch: [fromImmutable, validateInfographic],
      remove: []
    },

    after: {
      all: [toImmutable(InfographicRecord)],
      find: [],
      get: [setInState("infographics")],
      create: [setInState("infographics"), hydrateMarker],
      update: [setInState("infographics")],
      patch: [setInState("infographics")],
      remove: [deleteInState("infographics"), hydrateMarker]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/infographics-setup.js